import RoutePath from '../../../pure-js/libs/RoutePath'
import config from '../Config'

export const ACTION_CODE_SETTINGS = {
  url: `${config.appUrl}${RoutePath.ROOT}`,
  handleCodeInApp: true
}
